import { CalculatorDescription } from '../../../lib/calculators/calculator-description';
import { CalculatorId } from '../../../lib/calculators/calculator-config';

export const boxPlotDescription: CalculatorDescription = {
  id: CalculatorId.BoxPlot,
  title: 'Box Plot Generator',
  metaTitle: 'Online Box Plot Maker - Create Box and Whisker Plots',
  description: 'Generate box and whisker plots to visualize data distribution, quartiles, and identify outliers. Perfect for comparing distributions across groups.',
  metaDescription: 'Create box plots online. Visualize data distributions, quartiles, and outliers with our free box and whisker plot generator.',
  howTo: {
    title: 'How to Create a Box Plot',
    steps: [
      'Enter your dataset(s) in the table or paste from spreadsheet',
      'Select the data columns to plot',
      'Choose between standard or custom whisker length',
      'Configure outlier display settings',
      'Add a title and customize the appearance',
      'Your box plot will update automatically as you make changes'
    ],
    graphic: {
      description: 'A step-by-step guide showing how to create a box plot from data input to final visualization'
    }
  },
  examples: [
    {
      title: 'Student Test Scores',
      description: 'Comparing test performance across different classes',
      dataDescription: 'Test scores for multiple classes',
      insights: [
        'Shows score distribution for each class',
        'Identifies median and quartile ranges',
        'Highlights potential outliers',
        'Enables easy comparison between classes'
      ]
    },
    {
      title: 'Monthly Temperature Ranges',
      description: 'Temperature variations throughout the year',
      dataDescription: 'Daily temperature readings by month',
      insights: [
        'Shows seasonal temperature patterns',
        'Displays temperature variability',
        'Identifies extreme temperatures',
        'Reveals climate trends'
      ]
    },
    {
      title: 'Product Quality Metrics',
      description: 'Quality measurements across production batches',
      dataDescription: 'Quality control measurements',
      insights: [
        'Visualizes quality consistency',
        'Identifies process variations',
        'Spots outlier batches',
        'Monitors quality control'
      ]
    }
  ],
  relatedCalculators: [
    CalculatorId.Histogram,
    CalculatorId.ScatterChart,
    CalculatorId.BarGraph
  ]
}; 